import React, { Component } from 'react';
import { Tag } from '@cimpress/react-components';

export default class TagDemo extends Component {
  state = {
    tags: [
      { value: 'foo' },
      { value: 'bar' },
      { value: 'baz' },
      {
        label: (
          <span>
            this has a <strong>label</strong>
          </span>
        ),
        value: 'tagWithLabel',
      },
    ],
  };

  onRemoveClick = value => {
    this.setState(prevState => {
      const tags = [...prevState.tags];
      const newTags = tags.filter(tag => tag.value === value);
      return { tags: newTags };
    });
  };

  render() {
    return (
      <div className="row">
        <div className="col-md-12">
          {this.state.tags.map(tag => (
            <Tag key={tag.value} {...tag} removable onRemoveClick={this.onRemoveClick} />
          ))}
          <Tag value="can't get rid of this one" />
          <Tag size="lg" value="Large tag" />
          <Tag size="sm" value="Small tag" />
        </div>
      </div>
    );
  }
}
